import {Component, Inject, OnInit} from "@angular/core";
import {MAT_DIALOG_DATA, MatDialogRef, MatDialogContent} from "@angular/material/dialog";
import {HomescreenService} from "../../../core/services/services/homescreen.service";
import {firstValueFrom} from "rxjs";
import {Role} from "../../../core/models/Role";
import {AuthenticationService} from "../../../core/services/services/authentication.service";
import {MatIcon} from "@angular/material/icon";
import {CdkScrollable} from "@angular/cdk/scrolling";
import {RequiresPermissionDirective} from "../../../shared/permission/directives/requires-permission.directive";
import {MatCard, MatCardTitle} from "@angular/material/card";
import {NgClass} from "@angular/common";
import {EscapeHotkeyDirective} from "../../../shared/hotkey/directives/escape-hotkey.directive";
import {SaveHotkeyDirective} from "../../../shared/hotkey/directives/save-hotkey.directive";
import {TranslatePipe} from "@ngx-translate/core";

interface FavoritesDialogData {
	isRoleInReadonly: boolean;
	isCustomerManager: boolean;
	deactivateSkillEdit: boolean;
}

@Component({
	selector: "app-dialog-edit-favorites",
	templateUrl: "./dialog-edit-favorites.component.html",
	styleUrls: ["./dialog-edit-favorites.component.scss"],
	imports: [
		MatIcon,
		CdkScrollable,
		MatDialogContent,
		RequiresPermissionDirective,
		MatCard,
		NgClass,
		MatCardTitle,
		EscapeHotkeyDirective,
		SaveHotkeyDirective,
		TranslatePipe,
	],
})
export class DialogEditFavoritesComponent implements OnInit {
	favorites;
	isRoleInReadonly: boolean;
	isCustomerManager: boolean;
	deactivateSkillEdit: boolean;
	isExternal: boolean = false;

	constructor(
		public dialogRef: MatDialogRef<DialogEditFavoritesComponent>,
		private homescreenService: HomescreenService,
		private loginService: AuthenticationService,
		@Inject(MAT_DIALOG_DATA) public data: FavoritesDialogData,
	) {}

	async ngOnInit(): Promise<void> {
		this.homescreenService.getFavorites().subscribe((value) => {
			this.favorites = value;
		});
		await firstValueFrom(this.loginService.getUserRoles()).then((res) => {
			this.isExternal = res.includes(Role.EXTERNAL);
		});
		this.isRoleInReadonly = this.data.isRoleInReadonly;
		this.isCustomerManager = this.data.isCustomerManager;
		this.deactivateSkillEdit = this.data.deactivateSkillEdit;
	}

	onSelectCard(i: number) {
		this.favorites.find((x) => x.id === i).enabled = !this.favorites.find((x) => x.id === i).enabled;
	}

	getSelected(i: number) {
		return this.favorites.find((x) => x.id === i).enabled;
	}

	saveFavorites() {
		this.homescreenService.saveFavorites(this.favorites).subscribe(() => {
			this.dialogRef.close(true);
		});
	}
}
